export default __webpack_public_path__ + "static/events-9d9475cde71d8f0fe89ee6367d62fb41.svg";